module.exports = {
          srcSet: __webpack_public_path__ + "900d2d197bc6d8fb00b5136d1448f77a-400.png"+" 400w",
          images:[ {path: __webpack_public_path__ + "900d2d197bc6d8fb00b5136d1448f77a-400.png",width: 400,height: 160}],
          src: __webpack_public_path__ + "900d2d197bc6d8fb00b5136d1448f77a-400.png",
          toString:function(){return __webpack_public_path__ + "900d2d197bc6d8fb00b5136d1448f77a-400.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAECAYAAAC3OK7NAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAWklEQVR4nFXMMQtBAQBF4Ycis02RslksDMrOr7HI3z+fnnqD4d473NMZMFQL7KsjdjhWm/Gb8qtqhi0eeOKCOw6Y/4HVuFe88K4+1e3PiNE47rk6YV2tsJzAL79se3CooLjpAAAAAElFTkSuQmCC",
          width: 400,
          height: 160
        }